document.addEventListener('DOMContentLoaded', function () {
  console.log('Gorgias chat loaded')

  //this seem to fix it by updating this file preview showing up
  if (!window.GorgiasChat) return
  console.log('Gorgias chat continue loading')

  GorgiasChat.init().then(function () {
    var chatDict = {
      clickToRetry: 'Click to retry.',
      contactFormAskAdditionalMessage:
        'Got it! If you can provide any other relevant details, such as your order number, please do so below.',
      contactFormAskEmail: 'Thank you for that info! Please provide the best email address for us to contact you:',
      contactFormAskMessage: 'We’re happy to help with that! Please provide any additional details below.',
      contactFormSSPUnsuccessfulAskAdditionalMessage:
        'Sorry to hear that! Share any additional details to help us assist you.',
      contactFormAskSubject: 'What can we help you with?',
      contactFormAskSubjectOther: 'What is the subject of your question?',
      contactFormEndingMessage: 'Thanks for your message! Our team will be in touch soon.',
      contactFormEndingMessageWithHelpCenter:
        'Thanks for your message! Our team will be in touch soon. In the meantime, visit our Help Center!',
      contactFormIntro:
        'Hi there! Leave us a message and our team will connect with you via email as soon as possible.',
      conversationTimestampHeaderFormat: 'MMMM D',
      actionPostbackError: 'An error occurred while processing your action. Please try again.',
      fetchHistory: 'Load more',
      fetchingHistory: 'Retrieving history...',
      invalidFileError:
        'Only images are supported. Choose a file with a supported extension (jpg, jpeg, png, gif, or bmp).',
      leaveAMessage: 'Leave A Message',
      leaveAnotherMessage: 'Leave Another Message',
      messageError: 'An error occurred while sending your message. Please try again.',
      messageIndicatorTitlePlural: '({count}) New messages',
      messageIndicatorTitleSingular: '({count}) New message',
      messageNotDelivered: 'Message not delivered. ',
      messageRelativeTimeDay: '{value}d ago',
      messageRelativeTimeHour: '{value}h ago',
      messageRelativeTimeJustNow: 'Just now',
      messageRelativeTimeMinute: '{value}m ago',
      messageTimestampFormat: 'h:mm A',
      messageSending: 'Sending...',
      messageDelivered: 'Delivered',
      tapToRetry: 'Message not delivered. Tap to retry.',
      unsupportedMessageType: 'Unsupported message type.',
      inputPlaceholder: 'Type a message...',
      emailCapturePlaceholder: 'your@email.com',
      emailCaptureInputLabel: 'Get notified by email',
      emailCaptureOnlineTriggerText: 'Leave us your email and we will reply soon.',
      emailCaptureOnlineThanksText: "Thanks! We'll email you at {email} if you leave.",
      emailCaptureOfflineTriggerText: "We're away, leave us your email and we'll respond shortly.",
      emailCaptureOfflineThanksText: "Thanks {email}! We'll get back to you shortly.",
      emailCaptureRequiredEmailPlaceholder: 'Leave your email',
      emailCaptureRequiredMessagePlaceholder: 'Write your message',
      backLabelBackInAMinute: 'Back in 1 minute',
      backLabelBackInMinutes: 'Back in {value} minutes',
      backLabelBackInAnHour: 'Back in 1 hour',
      backLabelBackInHours: 'Back in {value} hours',
      backLabelBackInDays: 'Back in {value} days',
      backLabelBackTomorrow: 'Back soon',
      campaignClickToReply: 'Click to reply',
      characters: 'characters',
      poweredBy: 'Powered by',
      productInformation: 'Product information',
      productQuestionShort: 'Product Question',
      shopClosingSoon: '{shopName} is closing in {minutes} minutes.',
      shopClosingInAMinute: '{shopName} is closing in 1 minute.',
      shopClosingInLessThanAMinute: '{shopName} is closing in less than 1 minute.',
      shopClosed: '{shopName} is now closed. Agents might not be available.',
      send: 'Send',
      usualReplyTimeDay: 'Typically replies within a day',
      usualReplyTimeHours: 'Typically replies in a few hours',
      usualReplyTimeMinutes: 'Typically replies in a few minutes',
      backLabelBackAt: 'Back online at {time}',
      backLabelBackOn: 'Back on {weekday}',
      emailCaptureTriggerTypicalReplyDay: 'We typically reply in a day.',
      emailCaptureTriggerTypicalReplyHours: 'We typically reply in a few hours.',
      emailCaptureTriggerTypicalReplyMinutes: 'We typically reply in a few minutes.',
      emailCaptureTriggerBackOnlineOn: "We'll be back online on {weekday}",
      emailCaptureTriggerBackOnlineAt: "We'll be back online at {time}",
      emailCaptureThanksText: "Thanks for reaching out! You'll get replies here and in your email.",
      emailCaptureTriggerTextBase: "Leave us your email and we'll get back to you.",
      emailCaptureOnlineTriggerTextShortly: "Leave us your email and we'll get back to you shortly.",
      introductionText: 'How can we help?',
      offlineIntroductionText: "We'll be back soon",
      subject: 'Subject',
      thatsAll: "That's all",
      headerText: 'Gorgias Team',
      poweredByGorgias: 'Powered by Gorgias',
      unsupportedActionType: 'Unsupported action type.',
    }

    window.GORGIAS_CHAT_TEXTS = chatDict
    GorgiasChat.updateTexts(chatDict)

    // Customize the chat button
    var timer = setInterval(function () {
      var chatButtonHead = document
        .querySelector('#gorgias-chat-container')
        ?.querySelector('#chat-button')
        ?.contentWindow.document.querySelector('head')
      if (!chatButtonHead || ![...chatButtonHead?.children].some((x) => x.getAttribute('data-emotion'))) {
        return
      }
      clearInterval(timer)

      const buttonStyle = document.createElement('style')
      buttonStyle.textContent = `
                #gorgias-chat-messenger-button {
                    background-color: #85d0cc; 
                    transition: background-color .3s ease-out;
                }
            `

      chatButtonHead.appendChild(buttonStyle)
    }, 50)

    // Customize the chat window
    GorgiasChat.on('widget:opened', function () {
      var timer = setInterval(function () {
        var chatWindowHead = document
          .querySelector('#gorgias-chat-container')
          ?.querySelector('#chat-window')
          ?.contentWindow.document.querySelector('head')
        if (![...chatWindowHead?.children].some((x) => x.getAttribute('data-emotion'))) {
          return
        }
        clearInterval(timer)

        var chatStyle = document.createElement('style')
        chatStyle.textContent = `
                    .message-window-iframe-p659u,
                    .message-window-iframe-1bymxkt {
                        background-color: #85d0cc !important;
                    }
                `

        chatWindowHead.appendChild(chatStyle)
      }, 50)
    })
  })
})
